import {Component} from '@angular/core';

@Component({
  selector: 'spt-community-guidelines',
  templateUrl: './community-guidelines.component.html',
  styleUrls: ['./community-guidelines.component.scss']
})
export class CommunityGuidelinesComponent {}
